import { render, staticRenderFns } from "./dialongAddNewStucture.vue?vue&type=template&id=1fdd4e4d"
import script from "./dialongAddNewStucture.vue?vue&type=script&lang=js"
export * from "./dialongAddNewStucture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports